module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', ["404"])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-528e0ce0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 25
// module chunks = 1